import * as amplitudeBrowser from '@amplitude/analytics-browser';

export const amplitudeLogger = (amplitudeConfig: Record<string, any>) => ({
  track: (
    eventInput: amplitudeBrowser.Types.BaseEvent | string,
    eventProperties?: Record<string, any>,
  ) =>
    amplitudeBrowser.track(eventInput, {
      ...amplitudeConfig,
      ...eventProperties,
    }),
});
